import uniq from "lodash/uniq";
import { escape, addToQuery, predicate, not } from "views/logic/queries/QueryHelper";
import { updateQueryString } from "views/logic/slices/viewSlice";
import { selectQueryString } from "views/logic/slices/viewSelectors";
import hasMultipleValueForActions from "views/components/visualizations/utils/hasMultipleValueForActions";
const formatNewQuery = (oldQuery, field, value) => {
  const fieldPredicate = not(predicate(field, escape(value)));
  return addToQuery(oldQuery, fieldPredicate);
};
const ExcludeFromQueryHandler = ({ queryId, field, value, contexts }) => (dispatch, getState) => {
  const oldQuery = selectQueryString(queryId)(getState());
  const valuesToAdd = uniq(
    hasMultipleValueForActions(contexts) ? contexts.valuePath.map(() => ({ field, value })) : [{ field, value }]
  );
  const newQuery = valuesToAdd.reduce(
    (prev, valueToAdd) => formatNewQuery(prev, valueToAdd.field, valueToAdd.value),
    oldQuery
  );
  return dispatch(updateQueryString(queryId, newQuery));
};
export default ExcludeFromQueryHandler;
